export default "__VITE_ASSET__e06eaa65__"